import { Paper, Stack } from "@mui/material";
import { useState } from "react";

import type {
  EnergyAnalysisCategoryTotal,
  EnergyAnalysisTotalChartType,
  EnergyAnalysisTrendChartType,
  EnergyAnalysisTrendSeries,
} from "../model/types";

import { ENERGY_ANALYSIS_TOTAL_CHART_TYPE, ENERGY_ANALYSIS_TREND_CHART_TYPE } from "../model/constants";
import { EnergyAnalysisTotalChart } from "./EnergyAnalysisTotalChart";
import { EnergyAnalysisTrendChart } from "./EnergyAnalysisTrendChart";

type EnergyAnalysisSplitChartsProps = {
  categoryTotals: EnergyAnalysisCategoryTotal[];
  snapshotValueMax: number;
  totalChartTitle: string;
  totalValue: number;
  trendChartTitle: string;
  trendSeries: EnergyAnalysisTrendSeries[];
  unit: string;
  years: number[];
};

export const EnergyAnalysisSplitCharts = ({
  categoryTotals,
  snapshotValueMax,
  totalChartTitle,
  totalValue,
  trendChartTitle,
  trendSeries,
  unit,
  years,
}: EnergyAnalysisSplitChartsProps) => {
  const [totalChartType, setTotalChartType] = useState<EnergyAnalysisTotalChartType>(
    ENERGY_ANALYSIS_TOTAL_CHART_TYPE.doughnut
  );
  const [trendChartType, setTrendChartType] = useState<EnergyAnalysisTrendChartType>(
    ENERGY_ANALYSIS_TREND_CHART_TYPE.stackedBar
  );
  return (
    <Stack className="w-full items-stretch gap-4">
      <Paper className="w-[36%] overflow-hidden !p-4">
        <EnergyAnalysisTotalChart
          categoryTotals={categoryTotals}
          chartType={totalChartType}
          onChartTypeChange={setTotalChartType}
          snapshotValueMax={snapshotValueMax}
          title={totalChartTitle}
          totalValue={totalValue}
          unit={unit}
        />
      </Paper>
      <Paper className="w-[64%] overflow-hidden !p-4">
        <EnergyAnalysisTrendChart
          chartType={trendChartType}
          onChartTypeChange={setTrendChartType}
          series={trendSeries}
          title={trendChartTitle}
          years={years}
        />
      </Paper>
    </Stack>
  );
};
